import React from 'react';

import { isFeatureEnabled } from '@lumapps/features';
import { isSuperAdmin, isInstanceSuperAdmin } from '@lumapps/permissions';
import { useSelector } from '@lumapps/redux/react';
import { isConnected, isUserImpersonated } from '@lumapps/user/ducks/selectors';

import { PendoTrigger as PendoTriggerUI, PendoTriggerProps as PendoTriggerUIProps } from './PendoTrigger';

type ConnectedProps = Omit<PendoTriggerUIProps, 'isVisible'>;

export const PendoTrigger: React.FC<ConnectedProps> = (props) => {
    const isSuper = useSelector(isSuperAdmin);
    const isInstanceAdmin = useSelector(isInstanceSuperAdmin);
    const isPendoEnabled = useSelector(isFeatureEnabled('pendo-analytics'));
    const isUserConnected = useSelector(isConnected);
    const isImpersonated = useSelector(isUserImpersonated);

    const isVisible = isUserConnected && (isSuper || isInstanceAdmin) && isPendoEnabled && !isImpersonated;

    return <PendoTriggerUI {...props} isVisible={isVisible} />;
};

PendoTrigger.displayName = 'PendoTriggerConnected';
